<template>
  <div class="none">
    <a-tooltip v-if="type==1" placement="top">
      <template slot="title">
        <span>多个机器人id,请使用英文逗号","隔开,不要换行！！！</span>
      </template>
      <input v-model="editMark" @blur="blurRemark" />
    </a-tooltip>
    <input v-if="type!=1" v-model="editMark" @blur="blurRemark" />
  </div>
</template>

<script>
export default {
  data(){
    return {
      editMark: this.iptVal,
    }
  },

  props: {
    iptVal: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: 0
    }
  },

  methods: {
    blurRemark(){
      this.$emit('blurRemark', this.editMark)
    },
  },

}
</script>

<style scoped>

.block {
  display: block;
}

.none {
  display: none;
}

</style>